<template>
  <div ref="layout" v-loading="loading" class="page-form">
    <h3 class="title">瓶储价格折扣金额调整</h3>
    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <form-button name="返回" @click="$router.go(-1)" />
        <form-button name="保存" type="primary" @click="saveData" />
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        label-width="150px"
        :model="formData"
        :rules="rules"
        :show-message="false"
      >
        <el-row :gutter="24">
          <el-col :lg="12" :md="12">
            <el-form-item prop="amount" label="瓶储价格折扣金额">
              <el-input
                v-model="formData.amount"
                placeholder="请输入瓶储价格折扣金额"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { apiDropvalueMod, apiGetDropvalue } from '@/api/sap/common-sap'
import { mapGetters } from 'vuex'

export default {
  name: 'BottleStoragePriceAdjust',
  data() {
    const rules = {
      amount: [
        { required: true, message: '请输入瓶储价格折扣金额', trigger: 'blur' },
        { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的金额格式（最多两位小数）', trigger: 'blur' }
      ]
    }
    return {
      rules,
      loading: false,
      errorList: [],
      formData: {
        amount: ''
      }
    }
  },
  computed: {
    ...mapGetters(['role', 'customerInfo'])
  },
  created() {
    this.queryCurrentValue()
  },
  methods: {
    async queryCurrentValue() {
      // 查询当前字典值
      try {
        const { DATA } = await apiGetDropvalue('A0086', {
          value_id: [
            {
              sign: 'I',
              option: 'EQ',
              low: 'V001',
              high: ''
            }
          ]
        })
        if (DATA && DATA.length > 0) {
          const item = DATA.find(v => v.value_id === 'V001')
          if (item) {
            this.formData.amount = item.value_kt || ''
          }
        }
      } catch (e) {
        console.error('查询当前值失败', e)
      }
    },
    async saveData() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          const params = {
            user_bp: this.$store.getters.role.USER_BP,
            mode: 'UPDATE',
            type: 'A0086',
            data: [
              {
                value_id: 'V001',
                value_kt: this.formData.amount,
                status: 0,
                sequence: '1'
              }
            ],
            role: 'WLYALL'
          }

          this.loading = true
          try {
            const { message, msgtype } = await apiDropvalueMod(params)
            if (msgtype === 'S') {
              this.$message.success(message || '保存成功')
            } else {
              this.$message.error(message || '保存失败')
            }
          } catch (e) {
            this.$message.error('保存失败，请稍后重试')
            console.error('保存失败', e)
          }
          this.loading = false
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-form {
  padding: 0 15px 15px;
  text-align: left;
  background: #ffffff;
}
</style>




// WEBPACK FOOTER //
// src/views/price-manage/bottleStoragePriceAdjust.vue